import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Helper } from "../core/util/helper.js";
import HttpDocumentsService from "./http_document_service.js";
import { DocumentDetailsEntity } from "../documentDetails/documentDetails.js";
import {
    CheckIfExistsResult,
    ConfigData,
    DocumentListItem,
    DocumentService
} from "./documents.js";

interface InMemConfiguration {
    canRead: boolean,
    canWrite: boolean,
    isExtern: boolean
}

export default class InMemoryDocumentsService implements DocumentService {
    private inMemDokuIds = [];
    private inMemConfig: InMemConfiguration;

    constructor(inMemDocs: string[], config: InMemConfiguration) {
        this.inMemDokuIds = inMemDocs || [];
        this.inMemConfig = config;
    }

    private AddDocument = (documentId: string) => {
        if (this.inMemDokuIds.indexOf(documentId) == -1) {
            this.inMemDokuIds.push(documentId);
        }
    }

    GetDocuments(type: any, documentKeyVal1: any, documentKeyVal2: any): Promise<JsonResultClass<DocumentListItem[]>> {
        return HTTPService.post<JsonResultClass>("Document/GetDocumentsByIds", { docIds: this.inMemDokuIds })
    }

    LoadConfig(type: any, id: any): Promise<JsonResultClass<ConfigData>> {
        return new Promise<JsonResultClass<ConfigData>>((resolve => {
            HTTPService.get("Document/GetDocumentFrameTranslations")
                .then((translations: JsonResultClass<any>) => {
                    const configData: ConfigData = {
                        rights: { canRead: true, canWrite: this.inMemConfig.canWrite, isExtern: this.inMemConfig.isExtern },
                        translations: translations.Data.translations
                    };
                    const result: JsonResultClass<ConfigData> = { Data: configData, Code: 0, Message: null, Id: null, AdditionalData: null }
                    resolve(result);
                })
        }));

    }

    SaveDocumentRelationship(dokuId: any, type: any, documentKeyVal1: any, documentKeyVal2: any): Promise<JsonResultClass<any>> {
        this.AddDocument(dokuId);
        return new Promise<JsonResultClass>((resolve) => {
            resolve({ Code: 0, AdditionalData: null, Data: null, Id: null, Message: null });
        });
    }

    SaveDocumentsRelationships(isGuids: string[], type: any, documentKeyVal1: any, documentKeyVal2: any, table: string): Promise<JsonResultClass<any>> {
        for (let isGuid of isGuids) {
            this.AddDocument(isGuid);
        }
        return HTTPService.post<JsonResultClass>("Document/SaveDocumentsRelationships", {
            isGuids: isGuids,
            type: type,
            id: documentKeyVal1 + (Helper.hasValue(documentKeyVal2) ? "|" + documentKeyVal2 : ""),
            table: table
        });
    }

    GetDocumentDetails(dokuId: any, type: any, refId: any): Promise<JsonResultClass<DocumentDetailsEntity>> {
        return new HttpDocumentsService()
            .GetDocumentDetails(dokuId, type, refId);
    }

    DeleteRelationShip(dokuId: any, type: any, documentKeyVal1: any, documentKeyVal2: any): Promise<JsonResultClass<any>> {
        return this.DeleteDocument(dokuId, type, null);
    }

    InitHyperlink(url: string, type: any, refId: any): Promise<JsonResultClass<any>> {
        return new Promise<JsonResultClass>((resolve) => {
            return HTTPService.get<JsonResultClass>("Document/InitHyperLink?Url=" + url + "&type=" + type + "&id=" + refId)
                .then(result => {
                    this.AddDocument(result.Data.Dokuid);
                    resolve(result);
                });
        });
    }

    DeleteDocument(dokuId: any, type: any, refId: any): Promise<JsonResultClass<any>> {
        this.inMemDokuIds.splice(this.inMemDokuIds.indexOf(dokuId), 1);

        return new Promise<JsonResultClass>((resolve) => {
            resolve({ Code: 0, AdditionalData: null, Data: null, Id: null, Message: null });
        });
    }

    DocumentExists(type: any, documentKeyVal1: any, documentKeyVal2: any, fileName: any): Promise<CheckIfExistsResult> {
        return new Promise<CheckIfExistsResult>((resolve) => {
            resolve({ exists: false, multiple: false, id: null });
        })
    }

    DocumentsExists(type: any, documentKeyVal1: any, documentKeyVal2: any, fileName: any): Promise<CheckIfExistsResult> {
        return new Promise<CheckIfExistsResult>((resolve) => {
            resolve({ exists: false, multiple: false, id: null });
        })
    }

    UploadDocument = (formData: FormData) => {
        return new Promise<JsonResultClass>((resolve) => {
            return new HttpDocumentsService()
                .UploadDocument(formData)
                .then(result => {
                    this.AddDocument(result.Data);
                    resolve(result);
                });
        });
    }
    UploadDocuments = (formData: FormData) => {
        return new Promise<JsonResultClass>((resolve) => {
            return new HttpDocumentsService()
                .UploadDocuments(formData)
                .then(result => {
                    (result.Data as any).forEach((id) => this.AddDocument(id))
                    resolve(result);
                });
        });
    }

    CheckIfReferencesExists = (isGuid: string) => {
        return new Promise<JsonResultClass<boolean>>((resolve) => {
            resolve({ Code: 0, AdditionalData: null, Data: false, Id: null, Message: null });
        })
    }

    GetRights = () => {
        return {canWrite: this.inMemConfig.canWrite, canRead: this.inMemConfig.canRead, isExtern: this.inMemConfig.isExtern};
    }
}